import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmUiToolbarComponent } from './sm-ui-toolbar.component';
import { SmConfirmModule } from '../sm-confirm/sm-confirm.module';



@NgModule({
  declarations: [SmUiToolbarComponent],
  imports: [
    CommonModule,
    SmConfirmModule
  ],
  exports:[SmUiToolbarComponent]
})
export class SmUiToolbarModule { }
